<template>
   <div class="container px-0 bg-danger">
   <div class="offcanvas offcanvas-end rounded-2 shadow" 
         data-bs-scroll="true" 
         data-bs-backdrop="false" 
         tabindex="-1" 
         id="offcanvasAttDelete" 
         aria-labelledby="offcanvasAttDeleteLabel"
         @blur="focusOff()"
      >
      <!--
         @blur="focusOff()"
         <button type="button" class="btn-close btn-sm text-reset" data-bs-dismiss="offcanvas" aria-label="Close" ref="btn_out_offcanvas"></button>
      -->
      <div class="offcanvas-header">
         <h6 id="offcanvasAttDeleteLabel">¿Desea {{textAttach}} el adjunto?</h6>
         <button type="button" 
            id="btn_close_offcanvas"
            class="btn-close btn-sm text-reset" 
            data-bs-dismiss="offcanvas" 
            aria-label="Close" 
            ref="btn_close_offcanvas"
         ></button>
      </div>
      <hr class="m-0"/>
      <div class="text-center tc-gray">
         <b>{{attachName}}</b>
      </div>
      <hr class="m-0"/>
      <div class="offcanvas-body text-center">
         <p v-if="putOff" >La operación de QUITAR un adjunto no es permanente. Es posible recuperarlo nuevamente.</p>
         <p v-else >La operación de BORRAR un adjunto es permanente. No es posible deshacer la operación.</p>
         <div class="row px-1 pt-2 gap-1">
            <div class="fp-onOff btn-danger rounded" @click="deleteAtt(attachId)">
               {{textAttach}}
            </div>
         </div>
      </div>
   </div>
   </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { useStore } from 'vuex'

import WspService from "../workSpace.service";

export default {
   
   components: {
   },
   
   setup() {
      const store = useStore()

      const boardId = ref(null)
      const btn_out_offcanvas = ref(null)
      const cnttId = ref(store.state.wspace.contentId)
      const cellId = ref(0)
      const attachId = ref(0)
      const attachName = ref("")
      const textAttach = ref('Quitar')
      const putOff = ref(true)

      onMounted(() => {
         let myOffCanvas = document.getElementById('offcanvasAttDelete')
         myOffCanvas.addEventListener('shown.bs.offcanvas', function (event) {
         cnttId.value = store.state.wspace.contentId
         let button = event.relatedTarget
         cellId.value = button.getAttribute('data-cell-id')
         attachId.value = button.getAttribute('data-attach-id')
         attachName.value = button.getAttribute('data-attach-name')
         putOff.value = (button.getAttribute('data-attach-put-off') === 'true')
         //console.log(button.getAttribute('data-attach-put-off') === 'true')
         //console.log(button.getAttribute('data-attach-put-off'))
         boardId.value = WspService.getBoardId(store)
         textAttach.value = putOff.value ? 'Quitar' : 'Borrar'
         console.log(attachName.value)
         myOffCanvas.focus()
         console.log(" show delete Attach's OC")
         })
         console.log("delete attach's OC")
      })
      
      function deleteAtt(attachId) {
         let cnttData = {}
            if (putOff.value) {
               cnttData.putOffAttachId = attachId
            } else {
               cnttData.deletAttachId = attachId
            }
            cnttData.userId = store.state.auth.user.id
         WspService.upContent(
            cnttId.value,    // contentId,
            cellId.value,    // cellId,
            boardId.value,   // boardId
            putOff.value ? 'ATP' : 'ATD',   // code
            cnttData    // cnttData
         )
         .then(response => {
            console.log("upDates > Id: "+response.data)
            store.dispatch("wspace/setContentId", -7)
         })
         .catch(error => {
            console.log(error);
         });
      }
      
      function focusOff() {
         console.log('out-focus-offcanvas')
         //
         store.dispatch("wspace/setOffCanvas", 4)
         //setTimeout(btn_out_offcanvas.value.click(),125)
         //
      }

      return {
         attachId,
         attachName,
         cnttId,
         deleteAtt,
         focusOff,
         btn_out_offcanvas,
         textAttach,
         putOff
      }
   }
}
</script>

<style scoped>
.offcanvas-end {
  top: 25px;
  right: 100px;
  width: 360px;
  height: fit-content;
}
/*
   width: max-content;
   width: 170px;
*/
.btn-info {
   background-color: #e5e7e9;
   border-color: #e5e7e9 ;
}
.btn-info:hover {
   background-color:  #cacfd2 ;
}
.btn-save {
   opacity: .7;
   background-color: blue;
   color: white;
}
.btn-save:hover {
   opacity: 1;
}
.btn-sm {
   width: max-content;
}
.fp-onOff {
  width: 333px;
  height: 30px;
  text-align: center;
}
.tc-gray {
   color: gray;
}
.fs-11 {
   font-size: 11px;
}
</style>